// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1g0DY","itemTitle":"ClientEmergencyInfo_itemTitle__3VOq2","itemText":"ClientEmergencyInfo_itemText__3QayJ"};